import Layout from './LayoutLinearBar';

export default Layout;
